import { DynamicIcon, iconNames } from "lucide-react/dynamic";

const LEGACY = { pen: "pen-tool" };
export const iconName = (n) => LEGACY[n] || n || "rocket";

export function SiteIcon({ name, ...props }) {
  return <DynamicIcon name={iconName(name)} fallback={() => <span style={{ display: "inline-block", width: props.size, height: props.size }} />} {...props} />;
}

const TR = {
  "siyaset politika meclis devlet": ["landmark", "vote", "flag", "megaphone", "handshake", "users", "building-2", "scroll"],
  "seçim oy sandık": ["vote", "check-square", "ballot", "flag"],
  "hukuk adalet avukat mahkeme yasa kanun": ["scale", "gavel", "book-open", "file-text", "shield", "landmark"],
  "youtube video kanal": ["youtube", "video", "play", "clapperboard", "tv"],
  "mikrofon podcast konuşma radyo ses": ["mic", "mic-vocal", "podcast", "radio", "audio-lines", "speech", "volume-2"],
  "kamera fotoğraf çekim sinema film": ["camera", "video", "clapperboard", "film", "aperture", "image", "projector"],
  "televizyon tv yayın medya": ["tv", "monitor", "radio-tower", "cast", "newspaper"],
  "girişim girişimcilik iş şirket yatırım": ["rocket", "briefcase", "trending-up", "lightbulb", "building", "chart-line", "target"],
  "yazı yazar kitap kalem makale": ["pen-tool", "feather", "book", "book-open", "notebook-pen", "pencil", "newspaper"],
  "eğitim okul üniversite öğrenci akademi": ["graduation-cap", "school", "book-open", "library", "backpack"],
  "sağlık hastane doktor tıp": ["heart-pulse", "stethoscope", "hospital", "pill", "cross"],
  "spor futbol basketbol ödül": ["trophy", "dumbbell", "medal", "volleyball", "bike"],
  "müzik şarkı konser": ["music", "music-2", "headphones", "guitar", "piano"],
  "teknoloji yazılım bilgisayar kod dijital": ["cpu", "laptop", "code", "monitor-smartphone", "server", "wifi", "bot"],
  "para finans ekonomi banka bütçe": ["wallet", "banknote", "coins", "piggy-bank", "chart-bar", "landmark"],
  "çevre doğa ağaç yeşil iklim": ["leaf", "trees", "sprout", "sun", "recycle", "mountain"],
  "toplum halk insan gençlik aile": ["users", "user", "baby", "heart-handshake", "hand-heart", "house"],
  "dünya uluslararası küresel": ["globe", "earth", "plane", "map"],
  "şehir belediye kent": ["building-2", "city", "map-pin", "bus", "landmark"],
  "iletişim telefon mesaj eposta": ["phone", "mail", "message-circle", "send", "at-sign"],
  "sosyal instagram facebook twitter linkedin": ["instagram", "facebook", "twitter", "linkedin", "share-2"],
  "kültür sanat tiyatro resim": ["palette", "drama", "brush", "theater", "paintbrush"],
  "tarım köy çiftçi": ["tractor", "wheat", "sprout", "carrot"],
  "güvenlik polis asker koruma": ["shield", "shield-check", "lock", "siren"],
  "kalp sevgi gönüllü yardım": ["heart", "hand-heart", "heart-handshake", "gift"],
  "yıldız başarı hedef": ["star", "award", "target", "flag", "crown"],
  "zaman takvim tarih": ["clock", "calendar", "hourglass", "timer"],
  "ev konut": ["house", "home", "building"],
  "ulaşım araba yol": ["car", "bus", "train-front", "route", "plane"],
  "fikir vizyon düşünce": ["lightbulb", "eye", "brain", "sparkles", "telescope"],
};

const norm = (s) => s.toLocaleLowerCase("tr-TR").trim();
const NAMES = new Set(iconNames);

export function searchIcons(q, limit = 180) {
  const s = norm(q);
  if (!s) return iconNames.slice(0, limit);
  const hits = [];
  for (const [keys, list] of Object.entries(TR)) if (keys.split(" ").some((k) => k.startsWith(s) || (s.length > 2 && k.includes(s)))) hits.push(...list);
  const en = iconNames.filter((n) => n.includes(s.replace(/\s+/g, "-")));
  return [...new Set([...hits.filter((n) => NAMES.has(n)), ...en])].slice(0, limit);
}

export const ICON_COUNT = iconNames.length;
